import { AITraits } from "../aiHelpers";
import moveTraits from "./moveTraits";
import commonTraits from "./commonTraits";

export default {
  ...commonTraits,
  ...moveTraits,
} as Record<string, AITraits<any>>;
